/* eslint-disable no-param-reassign */
/*
 *
 * Copyright © Tessell Inc, 2021. All rights reserved.
 *
 *     Date            Author                  Comment
 *   --------------------------------------------------
 *     9/4/2021     bakul.banthia         Created
 *
 */

import { createSlice } from '@reduxjs/toolkit';

export const credits = createSlice({
    name: 'creditsData',
    initialState: {
        value: {},
    },
    reducers: {
        update: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const { update } = credits.actions;

export default credits.reducer;
